import styled, { css } from 'styled-components'

import { Card } from '@/components/ui/card'
import { Tooltip } from '@/components/ui/tooltip'
import { thinScrollbar } from '@/theme/common/scrollbar'

export const LoaderContainer = styled(Card)(
  () => css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,
)

export const PageCard = styled(Card)`
  overflow-y: auto;
  ${thinScrollbar}
`

export const FormLayout = styled.div(
  ({ theme }) => css`
    flex: 1;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${theme.space[40]};
    padding-top: ${theme.space[24]};
  `,
)

export const FieldsColumn = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space[32]};
  `,
)

export const ImageColumn = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space[16]};
    padding-top: ${theme.space[4]};
  `,
)

export const FieldGroup = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space[4]};
  `,
)

export const HelperText = styled.p(
  ({ theme }) => css`
    font-size: 1.2rem;
    line-height: 1.6rem;
    color: ${theme.colors.black500};
  `,
)

export const FieldRow = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${theme.space[8]};
    align-items: start;
  `,
)

export const InStockContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space[8]};
  `,
)

export const Footer = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: flex-end;
    gap: ${theme.space[12]};
    flex-shrink: 0;
    padding-top: ${theme.space[24]};
    margin-top: auto;
  `,
)

export const ImageSectionTitle = styled.p(
  ({ theme }) => css`
    font-size: 1.6rem;
    font-weight: 600;
    line-height: 2.4rem;
    color: ${theme.colors.black800};
  `,
)

export const ImageUploadSection = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space[4]};
  `,
)

export const ImageHelperText = styled.p(
  ({ theme }) => css`
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${theme.colors.black500};
    text-align: center;
  `,
)

export const ImagePreviewWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space[8]};
    border: ${theme.border.size[1]} solid ${theme.colors.gray500};
    border-radius: ${theme.border.radius[12]};
    overflow: hidden;
    padding: ${theme.space[12]};
  `,
)

export const ImagePreview = styled.img(
  ({ theme }) => css`
    width: 100%;
    height: 20rem;
    object-fit: contain;
    border-radius: ${theme.border.radius[8]};
  `,
)

export const RemoveImageButton = styled.button(
  ({ theme }) => css`
    background: none;
    border: none;
    color: ${theme.colors.red500};
    font-size: 1.2rem;
    cursor: pointer;
    text-align: center;
    padding: ${theme.space[4]};

    &:hover {
      text-decoration: underline;
    }
  `,
)

export const InlineTooltip = styled(Tooltip)`
  width: auto;
`

export const SkeletonSwitchRow = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space[8]};
  `,
)

export const SkeletonTextLines = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
